import styled from "styled-components";

const StyleWrapper = styled.div`

.p-accordion {
    border-radius: 0.75rem !important;
    border: 1px solid var(--neutral-lightgray, #D9DCE1)!important;
    background: transparent !important;
    .p-accordion-header {
        .p-accordion-header-link{
            display: flex;
            padding: 1rem;
            flex-direction: column;
            align-items: flex-start;
            gap: 1rem;
            align-self: stretch;
            border-radius: 0 !important;
            border: 0  !important;
            background: transparent !important;
            padding: 0.5rem !important;
        }
    }

    .p-accordion-content{
        background: transparent !important;
        border: 0  !important;
        padding: 1rem !important;
    }
    .p-accordion-header-text{
        width: 100%;
    }
}

.p-accordion .p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link {
    background: transparent !important;
}

.p-accordion-toggle-icon.pi {
  display: none;
}

.p-checkbox .p-checkbox-box.p-highlight {
    border-color: #6d43f0 !important;
    background: #6B47F5 !important;
}
.p-checkbox .p-checkbox-box .p-checkbox-icon{
    margin-left: 0;
    font-size: 10px;
    font-weight: 900;
}


.header_flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    .make_model{
        color: var(--text-dark-gray, #455560);
        /* Label En/S Label */
        font-family: Tawuniya;
        font-size: 0.875rem;
        font-style: normal;
        font-weight: 400;
        line-height: 0.875rem;
        .make{
            color: var(--primary-primary-color, #6B47F5);
            /* Label En/S Label */
            font-family: Tawuniya;
            font-size: 0.875rem;
            font-style: normal;
            font-weight: 400;
            line-height: 0.875rem; /* 100% */
        }
        .plate{
            color: var(--text-black, #1A1C1F);
            /* Label En Bold/S Label-Bold */
            font-family: Tawuniya;
            font-size: 0.875rem;
            font-style: normal;
            font-weight: 700;
            line-height: 0.875rem; /* 100% */
        }
    }
    .driver_label{
        display: flex;
        height: 1.375rem;
        padding: 0.3125rem 0.75rem;
        align-items: center;
        gap: 0.25rem;
        border-radius: 6.25rem;
        background: var(--White, #FFF);
        color: var(--text-dark-gray, #455560);
        /* Label En/XS Label */
        font-family: Tawuniya;
        font-size: 0.75rem;
        font-style: normal;
        font-weight: 400;
        line-height: 0.75rem; /* 100% */            
    }
}

.inner_content{
    display: flex;
    padding: 1.5rem 1rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 1.5rem;
    align-self: stretch;
    border-radius: var(--border-radius-12, 0.75rem);
    background: var(--White, #FFF);
    /* Shadow - Stacked */
    box-shadow: 0px 4px 10px 0px rgba(9, 30, 66, 0.00);  
    
    .desc{
        display: flex;
        align-items: flex-start;
        flex: 1 0 0;
        gap: 0.75rem;
        margin-bottom: 1.5rem;
        .ico{
            display: flex;
            align-items: flex-start;
        }
        .text{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            flex: 1 0 0;
            .title{
                color: var(--text-dark-gray, #455560);
                /* Label En/XSS Label */
                font-family: Tawuniya;
                font-size: 0.625rem;
                font-style: normal;
                font-weight: 400;
                line-height: 0.625rem; /* 100% */
                margin-bottom: 0.25rem;
            }
            .value{
                color: var(--text-black, #1A1C1F);
                /* Label En Bold/XS Label-Bold */
                font-family: Tawuniya;
                font-size: 0.75rem;
                font-style: normal;
                font-weight: 700;
                line-height: 0.75rem; /* 100% */
            }
        }
    }
}

h4{
    color: var(--text-black, #1A1C1F);
    /* Heading En/Heading Tiny */
    font-family: Tawuniya;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: 130%; /* 1.1375rem */
    letter-spacing: -0.0175rem;
    margin: 1rem 0;
}

.driver_list{
    margin-bottom: 0.75rem;
    display: flex;
    padding: 1rem .75rem;
    align-items: center;
    gap: 0.5rem;
    align-self: stretch;
    border-radius: 0.75rem;
    background: var(--White, #FFF);
    /* Shadow - Stacked */
    box-shadow: 0px 4px 10px 0px rgba(9, 30, 66, 0.00);
    .details_wrapper{
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        .name{
            color: var(--text-black, #1A1C1F);
            /* Label En Bold/S Label-Bold */
            font-family: Tawuniya;
            font-size: 0.875rem;
            font-style: normal;
            font-weight: 700;
            line-height: 0.875rem; /* 100% */            
        }
        .details{
            display: flex;
            gap:.5rem;
            color: var(--text-dark-gray, #455560);
            /* Label En/XS Label */
            font-family: Tawuniya;
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 0.75rem; /* 100% */            
        }
    }
    .badge{
        display: flex;
        padding: 0.3125rem 0.75rem;
        align-items: center;
        // gap: 0.25rem;
        border-radius: 6.25rem;
        background: var(--primary-light, #F8F6FF);
        color: var(--primary-primary-color, #6B47F5);
        /* Label En/XS Label */
        font-family: Tawuniya;
        font-size: 0.75rem;
        font-style: normal;
        font-weight: 400;
        line-height: 0.75rem; /* 100% */                        
    }
}

.add-driver-btn{
    display: flex;
    width: 100%;
    height: 2.625rem;
    padding: 0rem 1rem 0rem 0.625rem;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    align-self: stretch;
    border-radius: 0.375rem;
    background: var(--Secondary-Secondary-Color, #312E52);
    color: var(--Others-White-Button, #FFF);
    /* Label En/S Label */
    font-family: Tawuniya;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: 0.875rem; /* 100% */
    border: 1px solid #312E52;
}


.actions{
    display: flex;
    width: 100%;
    .save-b{
        display: flex;
        height: 2.625rem;
        width: 75%;
        padding: 0rem 0.625rem 0rem 1rem;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
        flex: 1 0 0;
        border-radius: 0.375rem;
        background: var(--Secondary-Secondary-Color, #312E52);
        color: var(--White, #FFF);
        /* Label En/S Label */
        font-family: Tawuniya;
        font-size: 0.875rem;
        font-style: normal;
        font-weight: 400;
        line-height: 0.875rem; /* 100% */
    }
    .close-b{
        display: flex;
        width: 7.5625rem;
        height: 2.625rem;
        padding: 0rem 1rem;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
        border-radius: 0.375rem;
        background: transparent;
        color: var(--Primary-Primary-Color, #6B47F5);
        /* Label En/S Label */
        font-family: Tawuniya;
        font-size: 0.875rem;
        font-style: normal;
        font-weight: 400;
        line-height: 0.875rem; /* 100% */
        border-color: transparent;
    }

}
.remove{
    cursor: pointer;
}

.p-inputnumber{
    width:100%;
}


.ar{
    .p-float-label {
      input {

        &:focus~label,
        &.p-filled~label {
          right: 1rem;
        }
      }

      label {
        right: 1rem;
      }
    }
}
  
`;

export default StyleWrapper;
